import { createSelector } from 'reselect';
import { getCurrentNavCat } from '../../CategoryListingPage/container/CategoryListingPage.selectors';

const selectShopThisStore = (state) => state?.ShopThisStore;

export const getNavigation = (state) => {
  return state?.Navigation?.navigationData;
};

export const getBreadCrumbs = (cid) =>
  createSelector(getNavigation, (navigation) => {
    return getCurrentNavCat(navigation, cid);
  });

export const getShopThisStoreL1categories = (state) => {
  return state?.ShopThisStore?.shopThisStoreL1categories;
};

export const getShopThisStoreL2categories = (state) => {
  return state?.ShopThisStore?.shopThisStoreL2categories;
};

export const getShopThisStoreL1categorySelection = createSelector(
  selectShopThisStore,
  (shopThisStore) => shopThisStore?.shopThisStoreL1Selection
);

export const getShopThisStoreL1categorySelectionLoaded = createSelector(
  selectShopThisStore,
  (shopThisStore) => shopThisStore?.shopThisStoreL1SelectionLoaded
);

export const getShopThisStoreL2CategoryGroupingSelection = createSelector(
  selectShopThisStore,
  (shopThisStore) => shopThisStore?.shopThisStoreL2GroupingSelection
);

export const getShopThisStoreL2CategoryGroupingSelectionLoaded = (state) => {
  return state?.ShopThisStore?.shopThisStoreL2GroupingSelectionLoaded;
};

export const getShopThisStoreL1categoryLoading = createSelector(
  selectShopThisStore,
  (shopThisStore) => shopThisStore?.isShopThisStoreL1categoriesLoading
);

export const getShopThisStoreL2categoryLoading = (state) => {
  return state?.ShopThisStore?.isShopThisStoreL2categoriesLoading;
};

export const getSelectedCategoryContent = (state) => {
  return state?.ShopThisStore?.selectedCategory;
};

export const getSelectedGroupId = (state) => {
  return state?.ShopThisStore?.selectedGroupId;
};

export const getIsLoadedInShopThisStore = (state) => {
  return state?.ShopThisStore?.loadedInShopThisStore;
};

export const getIsShopThisStoreHplpLoading = (state) => {
  return state?.ShopThisStore?.isShopThisStoreHplpLoaded;
};

export const getShowShopThisStoreNotification = (state) => {
  return state?.ShopThisStore?.showShopThisStoreNotification;
};

export const getFilteredList = (state) => {
  return state?.ShopThisStore?.filteredL2AndL1Categories;
};

export const getSTSL1categoriesFetched = (state) => {
  return state?.ShopThisStore?.shopThisStoreL1categoriesFetched;
};

export const getIsDefaultCategoryLoaded = createSelector(
  selectShopThisStore,
  (shopThisStore) => shopThisStore?.isDefaultCategoriesLoaded
);

export const getSelectedStoreL1Categories = createSelector(
  selectShopThisStore,
  (sts) => sts?.selectedStoreL1Categories
);

export const getSelectedStoreL2Categories = createSelector(
  selectShopThisStore,
  (sts) => sts?.selectedStoreL2Categories
);
